/**
 * Kernel API.
 */

import DownloadService from './services/network/downloadService.js';
import ParaViewService from './services/postProcessing/paraViewService.js';
import ReportingService from './services/network/reportingService.js';
// import WindowsService from "./services/windows/windowsService";
import WsClientService from './services/network/wsClientService.js';

class Kernel {

    /**
     * Create start script for ParaView.
     */
    static createParaViewStartScript(caseDir, params) {
        try {
            return ParaViewService.createParaViewStartScript(caseDir, params);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Submit an issue.
     */
    static submitIssue(caseDir, data) {
        try {
            return ReportingService.submitIssue(caseDir, data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Download a file.
     */
    static downloadAndInstall(programKey, url, installerType, installDir, cliArguments?: string) {
        try {
            return DownloadService.downloadAndInstall(programKey, url, installerType, installDir, cliArguments);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * WebSocket client.
     */
    static initWebSocket(url) {
        try {
            return WsClientService.initWebSocket(url);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Check if WebSocket client is connected.
     */
    static isWsClientConnected() {
        return WsClientService.isWsClientConnected();
    }

    /**
     * Check if WebSocket client is connected.
     */
    static sendWsMessage(message) {
        try {
            return WsClientService.sendWsMessage(message);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * Bring another window to front by its title.
     */
    static bringWindowToFront(title) {
        try {
            return Promise.resolve();
            // return WindowsService.bringWindowToFront(title);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}

export default Kernel;
